require('./cart-delivery-notes-form.scss');
var BaseViews = require('../../base');

var CartDeliveryNotesForm = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-delivery-notes-form',
    template: require('./cart-delivery-notes-form.html'),
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                _appChannel: null,
            }
        );
    },
    bindings: function () {
        var bindings = {
            '[name=deliveryNotes]':
                _.extend(
                    {},
                    {},
                    { observe: 'deliveryNotes' }
                )
        };

        return bindings;
    },
    onRender: function () {
        BaseViews.LayoutView.prototype.onRender.call(this);
    }
});
module.exports = CartDeliveryNotesForm;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-notes-form.js
 **/